import React, { useState } from "react";
import PropTypes from "prop-types";
import { useField } from "@formiz/core";
import {
  Box,
  useMediaQuery,
  TextField,
  Tooltip,
  IconButton,
  Typography
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

const CAIHField = props => {
  const { errorMessage, id, isValid, isSubmitted, setValue } = useField(props);
  const {
    fullWidth,
    type,
    defaultValue,
    label,
    required,
    disabled,
    toolTip
  } = props;
  const [isTouched, setIsTouched] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const showError = !isValid && (isTouched || isSubmitted);

  return (
    <Box>
      {label && (
        <Box mb={2}>
          <Typography variant="body1">
            {label}
            {toolTip && (
              <Tooltip title={toolTip.content} placement="right" arrow>
                <IconButton
                  sx={{ color: "cobalt.ultramarine" }}
                  aria-label="tooltip"
                  size="small"
                  disableRipple
                  disableFocusRipple
                >
                  {toolTip.icon}
                </IconButton>
              </Tooltip>
            )}
          </Typography>
        </Box>
      )}
      <TextField
        sx={{
          "& input": {
            height: "24px",
            width: "261px"
          },
          "& label": {
            marginBottom: "16px"
          }
        }}
        variant="outlined"
        error={showError}
        helperText={showError ? errorMessage : ""}
        id={id}
        type={type}
        size="small"
        autoComplete="off"
        disabled={disabled}
        required={required}
        defaultValue={defaultValue}
        onChange={e => setValue(e.target.value)}
        onBlur={() => setIsTouched(true)}
        fullWidth={fullWidth || isMobile}
      />
    </Box>
  );
};

CAIHField.propTypes = {
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  fullWidth: PropTypes.bool,
  type: PropTypes.string,
  defaultValue: PropTypes.string,
  label: PropTypes.string,
  toolTip: PropTypes.shape({
    icon: PropTypes.node.isRequired,
    content: PropTypes.node.isRequired
  })
};

CAIHField.defaultProps = {
  disabled: false,
  required: false,
  fullWidth: false,
  type: "text",
  defaultValue: "",
  label: "",
  toolTip: null
};

export default CAIHField;
